<template>
  <section class="style-section">
    <div class="title-guide">模块图标</div>
    <div class="img-guide">
      <div class="title-img">
        <el-image style="width: 200px; height: 200px" :src="url1" :fit="fit" />
      </div>
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">功能</div>
    <div class="content-guide">
      本模块用于建立装配式结构（空心板、T梁、小箱梁）包含桥墩部分的桥梁整体模型，
      采用桥梁整体模型计算桥墩立柱，在墩身计算长度的计算上更加准确，适应范围更广。
      同时整体模型也便于进行墩梁固结计算和抗震计算。
    </div>
    <div class="content-guide" style="font-weight: 600">
      本模块支持桥梁曲线布置，不支持斜交布置。
    </div>
    <div class="img-guide">
      <el-image
        class="size-img"
        style="width: 700px; height: 240px"
        :src="url2"
        :zoom-rate="1.2"
        :max-scale="1.5"
        :min-scale="0.2"
        :preview-src-list="srcList2"
        :initial-index="0"
        fit="cover"
      />
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">模块设计理念</div>
    <div class="content-guide">
      装配式结构桥墩计算一直以来都存在水平力分配计算复杂、墩身计算长度靠经验的问题。
      而抗震验算中，还需要建立包含上部构造的模型。如果采用传统的方式建模，
      上部构造的建模就非常麻烦，需要各种复制、移动单元，还需要考虑钢束问题。
      结合装配式上部构造模块的开发理念，可以考虑采用拼搭积木的方式去建立模型，
      上部构造仅需要引入建好的上部构造模块参数，而下部构造可以单独按设计图纸尺寸标注的方式去输入参数，
      再用相互间的几何关系将两部分连接起来，形成最终的全桥整体模型。
      这样的模型虽显复杂，但是既能够进行抗震验算，又能够采用有限元的方式进行水平力分配计算、墩身计算长度计算，
      计算结果的准确性将大大提高。
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">模块使用流程</div>
    <div class="content-guide">
      <div>本模块常规使用流程如下：</div>
      <li>定义孔跨布置——曲线桥梁引入路线文件</li>
      <li>定义桥面布置参数（桥面宽度布置）</li>
      <li>选择汽车荷载，输入人群荷载</li>
      <li>输入桥面铺装厚度</li>
      <li>
        导入每一联上部构造对应的项目文件（用装配式梁格模块建立的项目文件）
      </li>
      <li>设置每一联的结构类型（桥面连续或者结构连续）</li>
      <li>定义每一个桥墩的墩身高度、桩基长度</li>
      <li>点击“自动计算”按钮，让程序根据已输入参数自动匹配桥墩尺寸参数。</li>
      <li>核查各个桥墩的尺寸参数，补充地质参数</li>
      <li>
        切换到“其他参数”窗口，根据设计图纸调整材料参数等其他参数，如果需要考虑风荷载则勾选相应内容。
      </li>
      <li>切换到“导出参数”窗口，确定导出模型类型</li>
      <li>
        保存项目文件，然后导出mct文件，mct文件导入到Midas
        Civil后即可得到计算模型
      </li>
    </div>
    <div class="img-guide">
      <div class="title-img">
        <el-image
          class="size-img"
          style="width: 700px; height: 420px"
          :src="url3"
          :zoom-rate="1.2"
          :max-scale="1.5"
          :min-scale="0.2"
          :preview-src-list="srcList3"
          :initial-index="0"
          fit="cover"
        />
      </div>
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">桥梁基本参数</div>
    <div class="content-guide">
      <li>跨径组合</li>
      <div>
        根据自己的需要输入跨径组合，可以采用“3-30”、“20+20”、“29.94+30+30+29.94”这样的方式，如果桥梁存在多联，采用逗号分隔（英文字符），如“3-30,4-30,3-30”。多跨连接符号仅支持“+”和“-”。
      </div>
      <li>选择曲线时需要导入路线文件，路线文件格式详见相关说明。</li>
      <li>
        起点桩号——引入路线文件后，输入桥梁起点对应路线文件的桩号，程序将以该桩号为桥梁起点、结合路线文件计算桥梁各部位平面位置。
      </li>
    </div>
    <div class="img-guide">
      <div class="title-img">
        <el-image style="width: 490px; height: 100px" :src="url4" :fit="fit" />
      </div>
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">桥面布置</div>
    <div class="content-guide">
      <li>
        整幅、分幅——两者的区别主要在于模型中车道的计算和布置。选择整幅时，W6和W7如果输入0，
        则W5+W8作为一个行车道整体宽度按照规范中的对向行驶进行车道布置。车道布置考虑了偏载和居中两种工况。
      </li>
      <li>
        W1～W12——对应示意图各部位宽度。注意梁体的全宽必须大于桥面W1～W12的相加值，不然导出mct文件时会提示“桥面宽度超出梁板宽度”。
      </li>
      <li>荷载Q1～Q6——该荷载为除桥面铺装以外作用在桥面的其他荷载。</li>
      <div>Q1对应W1、W12宽度范围内的荷载（如人行道护栏、防撞护栏自重），</div>
      <div>Q2对应W2、W11宽度范围内的荷载(如人行道板自重)，</div>
      <div>
        Q3对应W3、W10宽度范围内的荷载（如非机动车道铺装调平层除开等厚部分自重），
      </div>
      <div>Q4对应W4、W9宽度范围内的荷载（如快慢车道分隔带自重），</div>
      <div>
        Q5对应W5、W8宽度范围内的荷载（如主行车道铺装调平层除开等厚部分自重），
      </div>
      <div>
        Q6对应W6、W7宽度范围内的荷载（如中央分隔带自重、分幅时右侧护栏自重）。
      </div>
      <div>特别注意荷载Q1～Q6的单位为kPa，即kN/m2。</div>
      <li>
        路线中心线到梁板边缘距离L1——本参数用于曲线桥时梁板的横向定位，便于计算梁体的精确位置。直线桥时本参数无意义，可填桥宽的一半。
      </li>
    </div>
    <div class="img-guide">
      <div class="title-img">
        <el-image style="width: 650px; height: 390px" :src="url5" :fit="fit" />
      </div>
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">桥面活荷载</div>
    <div class="content-guide">
      <li>
        汽车荷载——可以选择公路-Ⅰ级和公路-Ⅱ级。城-A级等效公路-Ⅰ级，城-B级等效公路-Ⅱ级。
      </li>
      <li>
        人群荷载——考虑人行道宽度后的人群荷载，该值不考虑横向分布系数，不考虑人群荷载时输入0。
      </li>
    </div>
    <div class="img-guide">
      <div class="title-img">
        <el-image style="width: 170px; height: 125px" :src="url6" :fit="fit" />
      </div>
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">桥面铺装</div>
    <div class="content-guide">
      <li>
        沥青混凝土层厚度——输入桥面沥青混凝土层的厚度。
        模型中该厚度乘以行车道宽度及密度（按24kN/m3取值）作为桥面荷载施加在梁体上。
        另外该厚度也用于温度梯度计算。桥梁没有该层时请输入数值0。
      </li>
      <li>
        水泥混凝土层厚度——输入结构宽度范围内水泥混凝土层的厚度。
        模型中该厚度乘以桥梁全宽及密度（按26kN/m3取值）作为桥面荷载施加在梁体上。
        如果沥青混凝土厚度为0，则程序按水泥混凝土铺装以该厚度作为温度梯度计算参数。
      </li>
    </div>
    <div class="img-guide">
      <div class="title-img">
        <el-image style="width: 200px; height: 125px" :src="url7" :fit="fit" />
      </div>
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">上部构造参数</div>
    <div class="content-guide">
      <li>本联信息</li>
      <div>
        切换不同的联，如果导入过上部构造文件，那么可以在下方“尺寸基本参数”和“材料基本参数”中查看到上部构造文件采用的基本参数，同时右下角可以看到相应的示意图。
      </div>
      <li>
        桥面连续、结构连续——选择本联的结构类型，注意每一联都需要单独选择。
      </li>
      <li>
        参数从文件中导入——点击并选择由本程序“装配式梁格模块”建立的上部构造项目文件。选择结构连续时，导入的上部构造文件需要为多跨结构连续模型。
        多跨结构不要求上部构造文件中孔数与本模块定义保存一致，比如3-40mT梁和4-40mT梁可以选择同一上部构造文件。
      </li>
    </div>
    <div class="img-guide">
      <div class="title-img">
        <el-image style="width: 700px; height: 154px" :src="url8" :fit="fit" />
      </div>
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">下部构造——指定墩身高度</div>
    <div class="content-guide">
      <li>
        墩梁固结——点击单元格可以切换“否”和“是”。
        选择“否”桥墩与上部构造的连接采用模拟支座的弹性连接，
        选择“是”桥墩与上部构造的连接则采用刚性连接
      </li>
      <li>墩高——墩身部分的高度，不不包含盖梁高度</li>
      <li>桩长——桩基部分的长度</li>
      <li>
        自动计算——点击后程序将按前面定义好的上部构造尺寸、墩身高度自动匹配合适的桥墩各部位尺寸
      </li>
      <li>
        参数复制——修改好一个桥墩尺寸参数后，允许将该桥墩参数复制给其他桥墩
      </li>
    </div>
    <div class="img-guide">
      <div class="title-img">
        <el-image style="width: 700px; height: 115px" :src="url9" :fit="fit" />
      </div>
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">下部构造——盖梁参数</div>
    <div class="content-guide">
      <li>盖梁截面类型支持矩形和T型。</li>
      <li>盖梁各部位参数意义如下（点击单元格右侧会显示示意图）：</li>
      <div>
        L1——盖梁左端线至路线中心线的距离，路线中心线在左侧时为负值、右侧时为正值。
      </div>
      <div>L2——盖梁左端变截面段长度，如果不存在变截面段，建议输入0.001</div>
      <div>L3——盖梁等高直线段长度</div>
      <div>L4——盖梁右端变截面段长度，如果不存在变截面段，建议输入0.001</div>
      <div>H1——盖梁中部高度</div>
      <div>H2——盖梁端部高度</div>
      <div>B1——盖梁全宽，T型截面为顶面全宽</div>
      <div>B2——T型截面腹板宽度</div>
      <div>H3——翼缘厚度1</div>
      <div>H4——翼缘厚度2</div>
    </div>
    <div class="img-guide">
      <div class="title-img">
        <el-image style="width: 700px; height: 65px" :src="url10" :fit="fit" />
      </div>
      <div class="title-img">
        <el-image
          style="width: 700px; height: 65px"
          :src="url10_1"
          :fit="fit"
        />
      </div>
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">下部构造——墩身参数</div>
    <div class="content-guide">
      <li>墩身截面类型支持圆形、矩形、空心截面。</li>
      <li>墩身各部位参数意义如下（点击单元格右侧会显示示意图）：</li>
      <div>根数——单个桥墩立柱的个数</div>
      <div>L1——盖梁左端线至第一根立柱中心线的距离</div>
      <div>L2——多根立柱的中心距</div>
      <div>D1——圆形截面的墩身直径</div>
      <div>B1——桥墩截面的总宽度</div>
      <div>H1——桥墩截面的总高度</div>
      <div>B2——空心内室净宽</div>
      <div>H2——空心内室净高</div>
      <div>T1——倒角宽度</div>
    </div>
    <div class="img-guide">
      <div class="title-img">
        <el-image style="width: 700px; height: 65px" :src="url11" :fit="fit" />
      </div>
      <div class="title-img">
        <el-image
          style="width: 700px; height: 65px"
          :src="url11_1"
          :fit="fit"
        />
      </div>
      <div class="title-img">
        <el-image
          style="width: 700px; height: 65px"
          :src="url11_2"
          :fit="fit"
        />
      </div>
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">下部构造——承台参数</div>
    <div class="content-guide">
      <li>承台截面类型支持整体式、分离式和无承台3种型式。</li>
      <div>整体式——用于单个桥墩下无论多少根立柱均采用一个统一的整体式承台</div>
      <div>分离式——用于单根立柱下设置独立的多桩承台</div>
      <div>无承台——用于常规桩柱直接相连。</div>
      <li>承台各部位参数意义如下（点击单元格右侧会显示示意图）：</li>
      <div>B1——承台平面横桥向宽度</div>
      <div>B2——承台平面顺桥向长度</div>
      <div>H1——承台高度</div>
    </div>
    <div class="img-guide">
      <div class="title-img">
        <el-image style="width: 256px; height: 103px" :src="url12" :fit="fit" />
      </div>
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">下部构造——桩基参数</div>
    <div class="content-guide">
      <li>桩基截面类型支持圆形和矩形截面。</li>
      <li>桩基各部位参数意义如下（点击单元格右侧会显示示意图）：</li>
      <div>顺桥向排数N1——单个承台范围内顺桥向桩基的排数</div>
      <div>横桥向排数N2——单个承台范围内横桥向桩基的排数</div>
      <div>顺桥向Ls1——单个承台范围内顺桥向桩基的间距</div>
      <div>横桥向Lh1——单个承台范围内横桥向桩基的间距</div>
      <div>D1——圆形桩基单根桩基直径</div>
      <div>B1——矩形桩基截面宽度</div>
      <div>H1——矩形桩基截面高度</div>
    </div>
    <div class="img-guide">
      <div class="title-img">
        <el-image style="width: 478px; height: 78px" :src="url13" :fit="fit" />
      </div>
      <div class="title-img">
        <el-image
          style="width: 478px; height: 78px"
          :src="url13_1"
          :fit="fit"
        />
      </div>
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">下部构造——系梁参数</div>
    <div class="content-guide">
      <li>系梁道数可以通过右侧“+”、“-”按钮进行增减</li>
      <li>系梁各部位参数意义如下（点击单元格右侧会显示示意图）：</li>
      <div>
        位置H1——按从上到下的顺序填写每一道系梁到承台顶面或桩基顶面（无承台）的距离。注意该参数不是系梁间距。
      </div>
      <div>墩身系梁截面B1——墩身系梁截面宽度</div>
      <div>墩身系梁截面H1——墩身系梁截面高度</div>
      <div>桩基系梁截面B1——桩基系梁截面宽度</div>
      <div>桩基系梁截面H1——桩基系梁截面高度</div>
    </div>
    <div class="img-guide">
      <div class="title-img">
        <el-image style="width: 253px; height: 259px" :src="url14" :fit="fit" />
      </div>
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">下部构造——地质参数</div>
    <div class="content-guide">
      <li>地质参数意义如下（点击单元格右侧会显示示意图）：</li>
      <div>地层数量可以通过右侧“+”、“-”按钮进行增减</div>
      <div>类型——有土体、岩体两种类型选择，通过点击单元格切换</div>
      <div>m值（C值）——土体类型填写对应的m值，岩体类型填写对应的C值</div>
      <div>厚度——相同参数地层的厚度</div>
      <li>注意：地层厚度之和应超过桩基长度，未含桩基的地层应删除。</li>
    </div>
    <div class="img-guide">
      <div class="title-img">
        <el-image style="width: 246px; height: 257px" :src="url15" :fit="fit" />
      </div>
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">下部构造——支座参数</div>
    <div class="content-guide">
      <li>支座各部位参数意义如下：</li>
      <div>
        支座类型——有方板支座、圆板支座、滑板支座、盆式支座、无支座，根据桥墩具体情况点击单元格切换。
      </div>
      <div>
        长度——板式支座平面上顺桥向的尺寸长度，通过点击单元格选择采用的尺寸
      </div>
      <div>
        宽度——板式支座平面上横桥向的尺寸长度，通过点击单元格选择采用的尺寸
      </div>
      <div>高度——板式支座的高度，通过点击单元格选择采用的尺寸</div>
      <li>注意：结构连续构造仅会有一排支座参数。</li>
    </div>
    <div class="img-guide">
      <div class="title-img">
        <el-image style="width: 251px; height: 259px" :src="url16" :fit="fit" />
      </div>
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">其他参数——混凝土标号</div>
    <div class="content-guide">
      <div>定义桥墩各部位采用的混凝土等级。</div>
    </div>
    <div class="img-guide">
      <div class="title-img">
        <el-image style="width: 700px; height: 54px" :src="url17" :fit="fit" />
      </div>
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">其他参数——收缩徐变</div>
    <div class="content-guide">
      <div>
        当导出模型采用“整体模型（简化）”方式时，用等效温降的办法计入上部构造收缩徐变对桥墩的影响。
        当导出模型采用“整体模型（完整）”方式时，该参数无意义。
      </div>
    </div>
    <div class="img-guide">
      <div class="title-img">
        <el-image style="width: 172px; height: 58px" :src="url18" :fit="fit" />
      </div>
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">其他参数——均匀温变荷载</div>
    <div class="content-guide">
      <div>
        根据桥位处气象情况分别输入整体温升、温降度数，注意实际使用应采用日平均温度的差值，或者采用规范建议值。
      </div>
    </div>
    <div class="img-guide">
      <div class="title-img">
        <el-image style="width: 266px; height: 60px" :src="url19" :fit="fit" />
      </div>
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">其他参数——汽车制动力参数</div>
    <div class="content-guide">
      <div>
        自行根据车道数输入需要计算汽车制动力的车道数，
        程序会按照每一联全长自动换算制动力大小。
        勾选“制动力反向”后，施加的制动力会向起点方向。
      </div>
    </div>
    <div class="img-guide">
      <div class="title-img">
        <el-image style="width: 348px; height: 56px" :src="url20" :fit="fit" />
      </div>
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">其他参数——抗震计算参数</div>
    <div class="content-guide">
      <div>
        进行抗震计算时，地基弹簧的约束刚度通常需要放大2～2.5倍，这里可以填写放大倍数，不需要再修改地质参数。
      </div>
    </div>
    <div class="img-guide">
      <div class="title-img">
        <el-image style="width: 203px; height: 56px" :src="url21" :fit="fit" />
      </div>
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">其他参数——风荷载参数</div>
    <div class="content-guide">
      <li>
        先选择地区，再点击“查询基本风速”，可以得到规范指定的U10和U100基本风速。
      </li>
      <li>
        地表分类——分A、B、C、D四类，分类依据见《公路桥梁抗风设计规范》（JTG/T
        3360-01-2018）表4.2.1。
      </li>
      <li>
        主梁基准高度——计算方法详见《公路桥梁抗风设计规范》（JTG/T
        3360-01-2018）第4.2.2、第4.2.3条。
      </li>
      <li>护栏高度——防撞护栏的高度，用于考虑防撞护栏受到的横向风荷载。</li>
      <li>
        通过勾选“考虑顺风向风荷载”和“考虑横风向风荷载”，在导出模型中生成对应的风荷载。
      </li>
      <li>
        计算过程——在成功导出mct文件后，点击该按钮可以查看到风荷载的详细计算过程。
      </li>
    </div>
    <div class="img-guide">
      <div class="title-img">
        <el-image style="width: 700px; height: 105px" :src="url22" :fit="fit" />
      </div>
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">其他参数——墩身计算长度</div>
    <div class="content-guide">
      <li>
        当采用“桥墩计算长度”方式导出模型时，可以利用模型在Midas
        Civil中的计算结果结合本工具计算某一个桥墩墩身在顺桥向的计算长度。
      </li>
      <li>各个参数意义如下</li>
      <div>墩身顺桥向惯性矩I1——单根立柱顺桥向的惯性矩</div>
      <div>桩基顺桥向惯性矩I1——单根立柱下桩基顺桥向的惯性矩</div>
      <div>墩身含盖梁高度——墩身部分+盖梁部分的总高度</div>
      <div>桩基含承台有效高度——桩基部分+承台部分的总高度</div>
      <div>临界力Pcr——在Midas Civil中读取并换算的该桥墩临界力</div>
      <div>
        读取墩身参数——点击本按钮并输入桥墩编号，可以自动读取该桥墩参数填入左侧的输入格中。
      </div>
      <div>
        计算——填好全部参数后，点击本按钮将计算出参数对应的“换算惯性矩”和“计算长度”结果显示在窗体上。
      </div>
      <li style="font-weight: 600">
        本功能的详细用法请在“技术”中查看文章“桥墩计算长度如何计算？”
      </li>
    </div>
    <div class="img-guide">
      <div class="title-img">
        <el-image style="width: 700px; height: 90px" :src="url23" :fit="fit" />
      </div>
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">其他参数——梁板墩台位置横向中心距</div>
    <div class="content-guide">
      <li>勾选“变宽桥梁”后，程序将允许考虑上部构造湿接缝变宽，通过控制每一跨梁间距来调整梁体位置。</li>
      <li>各部分参数意义如下：</li>
      <div>桥面参数L1——同桥面布置窗体中参数L1，指左侧护栏外边缘至梁板左侧外边缘水平距离。</div>
      <div>间距1～间距n——从左向右计数的各个梁在墩台位置的中心距离。支持同一个桥墩处前后跨中心距不一致的情况。</div>
    </div>
    <div class="img-guide">
      <div class="title-img">
        <el-image style="width: 700px; height: 270px" :src="url24" :fit="fit" />
      </div>
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">导出参数——基本参数</div>
    <div class="content-guide">
      <li>各部位参数意义如下：</li>
      <div>盖梁最大分段长度——用于控制盖梁分段数量</div>
      <div>墩身最大分段长度——用于控制墩身分段数量</div>
      <div>桩基最大分段长度——用于控制桩基分段数量</div>
      <div>墩身系梁间距——用于控制自动计算参数时墩身系梁的间距</div>
      <div>
        支座使用区域特性——根据实际情况选用，用于计算支座弹性连接的刚度系数
      </div>
      <div>支座体系厚度——用于程序中控制上部构造与盖梁间的距离</div>
      <div>桥墩挡块+间隙厚度——用于控制自动计算参数时盖梁的总长及横向位置</div>
    </div>
    <div class="img-guide">
      <div class="title-img">
        <el-image style="width: 700px; height: 85px" :src="url25" :fit="fit" />
      </div>
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">导出参数——导出模型</div>
    <div class="content-guide">
      <li>
        整体模型（简化）——采用本方式导出的模型，未包含上部构造的所有预应力钢束，上部构造的收缩徐变影响采用等效温降方式计入模型。
      </li>
      <li>
        整体模型（整体）——采用本方式导出的模型，包含上部构造的所有预应力钢束，主要用于考虑墩梁固结对上部构造影响的模型。
      </li>
      <li>
        桥墩计算长度模型——采用本方式导出的模型，仅适用于进行桥墩计算长度的计算。
      </li>
    </div>
    <div class="img-guide">
      <div class="title-img">
        <el-image style="width: 168px; height: 104px" :src="url26" :fit="fit" />
      </div>
    </div>
  </section>
  <el-divider></el-divider>
  <div style="height: 120px"></div>
</template>
<script>
export default {
  data() {
    return {
      url1: require("@/assets/png/unit3/1.png"),
      url2: require("@/assets/png/unit3/2.png"),
      url3: require("@/assets/png/unit3/3-1.png"),
      url4: require("@/assets/png/unit3/4.png"),
      url5: require("@/assets/png/unit3/5.png"),
      url6: require("@/assets/png/unit3/6.png"),
      url7: require("@/assets/png/unit3/7.png"),
      url8: require("@/assets/png/unit3/8.png"),
      url9: require("@/assets/png/unit3/9.png"),
      url10: require("@/assets/png/unit3/10.png"),
      url10_1: require("@/assets/png/unit3/10-1.png"),
      url11: require("@/assets/png/unit3/11.png"),
      url11_1: require("@/assets/png/unit3/11-1.png"),
      url11_2: require("@/assets/png/unit3/11-2.png"),
      url12: require("@/assets/png/unit3/12.png"),
      url13: require("@/assets/png/unit3/13.png"),
      url13_1: require("@/assets/png/unit3/13-1.png"),
      url14: require("@/assets/png/unit3/14.png"),
      url15: require("@/assets/png/unit3/15.png"),
      url16: require("@/assets/png/unit3/16.png"),
      url17: require("@/assets/png/unit3/17.png"),
      url18: require("@/assets/png/unit3/18.png"),
      url19: require("@/assets/png/unit3/19.png"),
      url20: require("@/assets/png/unit3/20.png"),
      url21: require("@/assets/png/unit3/21.png"),
      url22: require("@/assets/png/unit3/22.png"),
      url23: require("@/assets/png/unit3/23.png"),
      url24: require("@/assets/png/unit3/24.png"),
      url25: require("@/assets/png/unit3/25.png"),
      url26: require("@/assets/png/unit3/26.png"),
      fit: "fill",
      srcList3: [
        require("@/assets/png/unit3/3-1.png"),
        require("@/assets/png/unit3/3-2.png"),
        require("@/assets/png/unit3/3-3.png"),
        require("@/assets/png/unit3/3-4.png"),
      ],
      srcList2: [require("@/assets/png/unit3/2.png")],
      srcList5: [require("@/assets/png/unit3/5.png")],
    };
  },
};
</script>
